// Polyfills for browser compatibility
// This file should be imported before any other modules that might need these polyfills

// Polyfill for libraries that expect a Node-style global.
if (typeof global === 'undefined') {
  (window as any).global = globalThis;
}

// Polyfill for process.env if needed
if (typeof process === 'undefined') {
  (window as any).process = { env: {} };
}

// Ensure Buffer is available if needed
if (typeof Buffer === 'undefined') {
  // Simple Buffer polyfill for basic operations
  (window as any).Buffer = {
    from: (data: any) => new Uint8Array(data),
    isBuffer: (obj: any) => obj instanceof Uint8Array
  };
}

// Fix for Vite HMR client - define WS_TOKEN if not provided by Vite
// This is used by Vite's Hot Module Replacement (HMR) client
if (typeof (window as any).__WS_TOKEN__ === 'undefined') {
  Object.defineProperty(window, '__WS_TOKEN__', {
    value: '',
    writable: true,
    configurable: true
  });
}

console.log('Polyfills loaded successfully');
